function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 5px;\n  height: 5px;\n  position: relative;\n  top: -10px;\n  left: -20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  div.cell-buttons {\n    display: none;\n  }\n\n  &:hover {\n    div.cell-buttons {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  grid-column: 1;\n  grid-row: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React, { useState } from "react";
import propTypes from "prop-types";
import sumBy from "lodash/sumBy";
import { FaRegTrashAlt } from "react-icons/fa";
import { IoIosAdd as IoAdd, IoIosRemove as IoRemove } from "react-icons/io";
import HiddenInput from "./HiddenInput";
import _ from "lodash";
import { Table, LeftTable, TwoTableLayoutContainer, RightTableContainer, NumbersTr, LabelsTr, IconButton, CellButtons, StyledCell, ConfirmationText } from "./styles";
import Select from "../../../select";
import { PhaseAllocationsActionsEnum } from "../stateReducer";
import { CustomCompGroup } from "./CustomCompGroup";
import { context } from "../../../wr-context";
import { buildConfirmationModal } from "../../../modal/builders";
import Tooltip from "../../../Tooltip";
import { ModalScalingFactorsEnum } from "../../../modal/modal";
import styled from "styled-components";
var RoleRemoveButton = styled.div(_templateObject());
var Wrapper = styled.td(_templateObject1());
var CellContainer = styled.div(_templateObject2());
var CellContent = styled.div(_templateObject3());
var sumAllocations = function(allocations) {
    var sum = sumBy(allocations, function(v) {
        return +v;
    });
    return isNaN(sum) ? "n/a" : sum;
};
var getTargetIndex = function(e) {
    var ref;
    return Array.prototype.indexOf.call((ref = e.target.parentElement) === null || ref === void 0 ? void 0 : ref.children, e.target);
};
var phaseOptionMappings = {
    label: "id",
    value: "id"
};
export default function BreakdownTable(param) {
    var data = param.data, roles = param.roles, phases = param.phases, onAllocationChange = param.onAllocationChange, onPhaseChange = param.onPhaseChange, allPhases = param.allPhases, onAddRole = param.onAddRole, onRemoveRole = param.onRemoveRole, onRoleChange = param.onRoleChange, allRoles = param.allRoles, dispatch = param.dispatch, _effortUnit = param.effortUnit, effortUnit = _effortUnit === void 0 ? "" : _effortUnit, _customComponents = param.customComponents, customComponents = _customComponents === void 0 ? [] : _customComponents, parentId = param.parentId, hideDropdownsRow = param.hideDropdownsRow;
    // if (!data || !data.length) {
    //   return null
    // }
    var ref = _slicedToArray(useState(""), 2), dragOver = ref[0], setDragOver = ref[1];
    var handleDragStart = function(e) {
        var idx = getTargetIndex(e);
        e.dataTransfer.setData("colId", String(idx));
    };
    var handleDragOver = function(e) {
        return e.preventDefault();
    };
    var handleDragEnter = function(e) {
        return setDragOver(getTargetIndex(e));
    };
    var handleOnDrop = function(e) {
        var droppedColIndex = getTargetIndex(e);
        var draggedColIndex = +e.dataTransfer.getData("colId");
        dispatch({
            type: PhaseAllocationsActionsEnum.MoveWeek,
            droppedColIndex: droppedColIndex,
            draggedColIndex: draggedColIndex
        });
        setDragOver("");
    };
    var handleWeekDelete = function(weekIndex) {
        return context.actions.openModal(buildConfirmationModal({
            body: /*#__PURE__*/ React.createElement(ConfirmationText, null, "Are you sure you want to delete week ", weekIndex + 1, "?"),
            onConfirm: function() {
                return dispatch({
                    type: PhaseAllocationsActionsEnum.RemoveWeek,
                    index: weekIndex
                });
            },
            size: ModalScalingFactorsEnum.xsm
        }));
    };
    var handleRoleDelete = function(roleIndex, roleLabel) {
        return context.actions.openModal(buildConfirmationModal({
            body: /*#__PURE__*/ React.createElement(ConfirmationText, null, "Are you sure you want to delete the project role: ", roleLabel, "?"),
            onConfirm: function() {
                return onRemoveRole(roleIndex);
            },
            size: ModalScalingFactorsEnum.xsm
        }));
    };
    var hoursOrWeeks = effortUnit.toLowerCase() === "weeks" ? "" : _.capitalize(effortUnit.toLowerCase());
    return /*#__PURE__*/ React.createElement(TwoTableLayoutContainer, {
        hasCustomComponents: !!(customComponents === null || customComponents === void 0 ? void 0 : customComponents.length)
    }, /*#__PURE__*/ React.createElement(LeftTable, {
        customComponents: customComponents || []
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement(NumbersTr, null, /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: onAddRole
    }, /*#__PURE__*/ React.createElement(IoAdd, null)), !!roles.length && /*#__PURE__*/ React.createElement(Tooltip, {
        tooltip: "Delete Last Role",
        options: {
            placement: "bottom-start"
        },
        style: {
            display: "inline-flex",
            marginLeft: "6px"
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function() {
            var lastRoleIndex = roles.length - 1;
            handleRoleDelete(lastRoleIndex, roles[lastRoleIndex].label);
        }
    }, /*#__PURE__*/ React.createElement(IoRemove, null)))), /*#__PURE__*/ React.createElement("th", null, "Weeks"), customComponents === null || customComponents === void 0 ? void 0 : customComponents.map(function(comp) {
        return /*#__PURE__*/ React.createElement("th", null, comp.label);
    })), /*#__PURE__*/ React.createElement(LabelsTr, null, /*#__PURE__*/ React.createElement("th", null, "Project Role"), /*#__PURE__*/ React.createElement("th", null, hoursOrWeeks))), /*#__PURE__*/ React.createElement("tbody", null, roles.map(function(role, i) {
        return /*#__PURE__*/ React.createElement("tr", {
            key: i
        }, /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement(CellContainer, null, /*#__PURE__*/ React.createElement(CellContent, null, /*#__PURE__*/ React.createElement(RoleRemoveButton, {
            className: "cell-buttons"
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            tooltip: "Delete",
            options: {
                placement: "left"
            }
        }, /*#__PURE__*/ React.createElement(FaRegTrashAlt, {
            onClick: function() {
                handleRoleDelete(i, role.label);
            }
        })))), /*#__PURE__*/ React.createElement(CellContent, null, /*#__PURE__*/ React.createElement(Select, {
            value: role.label,
            options: allRoles,
            onChange: function(e, role) {
                return onRoleChange(e, role, i);
            },
            optionMappings: {
                value: "label",
                label: "label"
            },
            fullWidth: true
        })))), /*#__PURE__*/ React.createElement("td", null, sumAllocations(data[i])), /*#__PURE__*/ React.createElement(CustomCompGroup, {
            customComponents: customComponents,
            parentId: parentId,
            role: role,
            rolePos: i
        }));
    }))), /*#__PURE__*/ React.createElement(RightTableContainer, {
        hasCustomComponents: !!(customComponents === null || customComponents === void 0 ? void 0 : customComponents.length)
    }, /*#__PURE__*/ React.createElement(Table, null, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement(NumbersTr, null, phases.map(function(_, i) {
        return /*#__PURE__*/ React.createElement(StyledCell, {
            key: i,
            draggable: true,
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDrop: handleOnDrop,
            onDragEnter: handleDragEnter,
            dragOver: i === dragOver
        }, i + 1, /*#__PURE__*/ React.createElement(CellButtons, {
            className: "cell-buttons"
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            tooltip: "Delete",
            options: {
                placement: "bottom-end"
            },
            style: {
                display: "inline-flex"
            }
        }, /*#__PURE__*/ React.createElement(FaRegTrashAlt, {
            onClick: function() {
                return handleWeekDelete(i);
            }
        }))));
    })), /*#__PURE__*/ React.createElement(LabelsTr, null, !hideDropdownsRow && phases.map(function(phase, i) {
        return /*#__PURE__*/ React.createElement("th", {
            key: i,
            className: i === dragOver ? "dragOver" : undefined
        }, /*#__PURE__*/ React.createElement(Select, {
            value: phase,
            options: allPhases.map(function(phase) {
                return {
                    id: phase
                };
            }),
            onChange: function(e, v) {
                onPhaseChange(e, v.id, i);
            },
            optionMappings: phaseOptionMappings,
            fullWidth: true
        }));
    }))), /*#__PURE__*/ React.createElement("tbody", null, roles.map(function(row, i) {
        var ref, ref1;
        /*#__PURE__*/ return React.createElement("tr", {
            key: i
        }, (ref = data[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.call(ref, function(v, j) {
            return /*#__PURE__*/ React.createElement("td", {
                key: j,
                className: j === dragOver ? "dragOver" : undefined
            }, /*#__PURE__*/ React.createElement(HiddenInput, {
                type: "text",
                name: "".concat(i, ".").concat(j),
                value: v,
                onChange: onAllocationChange
            }));
        }));
    })))));
};
BreakdownTable.propTypes = {
    data: propTypes.arrayOf(propTypes.array).isRequired,
    allRoles: propTypes.array.isRequired,
    allPhases: propTypes.array.isRequired,
    roles: propTypes.array.isRequired,
    phases: propTypes.array.isRequired,
    onAddRole: propTypes.func.isRequired,
    onRemoveRole: propTypes.func.isRequired,
    onRoleChange: propTypes.func.isRequired,
    onAllocationChange: propTypes.func.isRequired,
    onPhaseChange: propTypes.func.isRequired,
    effortUnit: propTypes.string,
    parentId: propTypes.string,
    customComponents: propTypes.array,
    hideDropdownsRow: propTypes.bool
};
